import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserPersonalizationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "UserPersonalization",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 16.262A6.62 6.62 0 0 1 9.39 9.651c0-3.645 2.966-6.61 6.611-6.61s6.61 2.965 6.61 6.61A6.62 6.62 0 0 1 16 16.262m0-10.936c-2.384 0-4.326 1.94-4.326 4.325s1.942 4.325 4.326 4.325 4.325-1.94 4.325-4.325S18.385 5.326 16 5.326M6.857 29.706c-.631 0-1.143-.503-1.143-1.135 0-5.69 4.614-10.303 10.286-10.303.87 0 1.735.109 2.57.324.612.157.98.78.824 1.392-.158.61-.79.978-1.392.822A8 8 0 0 0 16 20.554c-4.41 0-8 3.589-8 8a1.15 1.15 0 0 1-1.143 1.152M27.429 22.857a3.433 3.433 0 0 1-3.43-3.429 1.143 1.143 0 1 0-2.285 0 3.433 3.433 0 0 1-3.429 3.429 1.143 1.143 0 0 0 0 2.286 3.43 3.43 0 0 1 3.43 3.428 1.143 1.143 0 1 0 2.284 0c0-1.89 1.54-3.428 3.43-3.428a1.143 1.143 0 0 0 0-2.286"
    })
  }));
};
UserPersonalizationIcon.displayName = 'UserPersonalizationIcon';